import { memo } from 'react';
import clsx from 'clsx';
import type { WorkOrderListItem } from '../../../../types/InfrastructureManagerTypes';
import CalendarPill from './CalendarPill';
import styles from './WorkOrderCalendar.module.scss';

interface CalendarDayCellProps {
  day: number;
  orders: WorkOrderListItem[] | undefined;
  selectedId: number | null;
  isOutside?: boolean;
  isToday?: boolean;
  onSelect: (id: number) => void;
  onExpand: (id: number) => void;
}

const CalendarDayCell = ({ day, orders, selectedId, isOutside, isToday, onSelect, onExpand }: CalendarDayCellProps) => (
  <div
    className={clsx(styles.calendarDayCell, {
      [styles.calendarDayCellOutside]: isOutside,
      [styles.calendarDayCellToday]: isToday,
    })}
  >
    <span className={styles.calendarDayNumber}>{day}</span>
    {orders ? (
      <ul className={styles.calendarDayPills}>
        {orders.map((order) => (
          <CalendarPill
            key={order.id}
            order={order}
            isSelected={order.id === selectedId}
            onSelect={onSelect}
            onExpand={onExpand}
          />
        ))}
      </ul>
    ) : null}
  </div>
);

export default memo(CalendarDayCell);
